import { useState, useEffect } from "react";
import { Eye, EyeOff } from "lucide-react";
import logo from "../../assets/Tweezer-Logo.svg";
import mobileLogo from "../../assets/mobile-logo.svg";
import msg from "../../assets/msg.svg";
import lock from "../../assets/lock.svg";
import api from "../../utils/apiConfig";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Adminlogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      const decodedToken = jwtDecode(token);
      if (decodedToken.exp * 1000 < Date.now()) {
        localStorage.removeItem("admin_token");
      } else {
        navigate("/twzpanel/dashboard");
      }
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post("/admin/login", {
        email: emailInput,
        password: passwordInput,
      });

      if (response.status === 200) {
        toast.success("Login successful");
        localStorage.setItem("admin_token", response.data.token);
        navigate("/twzpanel/dashboard");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      console.error("Error logging in:", error);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-white">
      <div className="flex flex-col justify-center items-center px-6 py-10 w-full max-w-md">
        <div className="flex justify-center py-6">
          <img
            src={logo}
            alt="Tweezers logo"
            className="w-20 hidden md:block"
          />
          <img
            src={mobileLogo}
            alt="Tweezers logo"
            className="w-20 block z-40 animate__animated animate__rotateIn md:hidden"
          />
        </div>
        <div className="w-full">
          <h2 className="mb-2 text-2xl font-bold text-secondary text-center">
            Admin Panel
          </h2>
          <p className="mb-6 text-sm text-gray-600 text-center">
            Only login via {" "}
            <span className="font-bold text-secondary">Email</span> {" "}
            is supported.
          </p>
          <form className="w-full">
            <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2">
              <img src={msg} alt="msg-icon" />
              <input
                type="text"
                placeholder="Email Address"
                className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
              />
            </div>
            <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2 relative">
              <img src={lock} alt="lock-icon" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute text-accent right-4 focus:outline-none"
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            <button 
              className="w-full rounded-2xl bg-primary text-white py-3 font-bold hover:bg-opacity-90"
              onClick={handleLogin}>
              Log in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Adminlogin;
